import MasterTokenAdAccount from './MasterTokenAdAccounts.Container';

export default MasterTokenAdAccount;
